import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '@spartacus/asm/root';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import * as config from '../shared/config/app.config';
import { BaseService } from '../shared/services/base.service';
import { DataLayerService } from '../shared/services/data-layer.service';

@Injectable({
  providedIn: 'root'
})
export class CustomProdPgService {
  public facets$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public category = new BehaviorSubject<any>(false);
  public sharedProductDetails = new BehaviorSubject<any>(false);
  public sharedProductVariantDetails = new BehaviorSubject<any>(false);
  category$ = this.category.asObservable();
  public cartItems = new BehaviorSubject<any>(false);
  cartItems$ = this.cartItems.asObservable();
  createdCart: any;
  itemsArr: any = [];
  createdCart$: any;
  public minicartUpdate = new Subject<any>();
  public stdCartMsg = new BehaviorSubject<any>(false);
  stdCartMsg$ = this.stdCartMsg.asObservable();
  public cartDetailsUpdate = new BehaviorSubject<any>(false);
  cartDetailsUpdate$ = this.cartDetailsUpdate.asObservable();
  public updateError = new BehaviorSubject<any>(false);
  updateError$ = this.updateError.asObservable();
  public formularyProducts = new BehaviorSubject<any>(false);
  formularyProducts$ = this.formularyProducts.asObservable();

  baseSite: any;

  public productCat = new Subject<any>();

  constructor(private readonly baseService: BaseService,
    private readonly occEndPoint: OccEndpointsService, private _dataService: DataLayerService) {
  }
  public getCategory(): any {
    this.baseSite = this.occEndPoint.getBaseUrl({
      baseUrl: false,
      prefix: false,
      baseSite: true,
    });
    if (this.baseSite === 'vsh') {
      this.baseService.get(config.CATEGORY).subscribe((res) => {
        this.category.next(res);
      });
    } else {
      this.baseService.get(config.VAXCATEGORY).subscribe((res) => {
        this.category.next(res);
      });
    }
  }
  public updateCart(productDetails, userId, cartId, productInfo?, type?): any {
    this.itemsArr = [];
    let contractFilter;
    if (productDetails?.selectedLocations && typeof (productDetails?.selectedLocations) == 'string') {
      this._dataService.addtoDataLayer('add_to_cart', productInfo, productDetails, type);
    } else {
      productDetails?.selectedLocations?.forEach(el => {
        this._dataService.addtoDataLayer('add_to_cart', productInfo, productDetails, type, el);
      });
    }
    this._dataService.addtoDataLayer('clearDataLayer', '', '', '');
    this.updateError.next(false);
    this.cartDetailsUpdate.next(false);
    this.minicartUpdate.next(false);
    this.stdCartMsg.next(false);
    this.baseService.post(config.USER_ACCOUNT + userId + '/carts/' + cartId + '/entries?fields=DEFAULT', productDetails).subscribe((res) => {
      if (res) {
        this.cartDetailsUpdate.next(true);
        this.minicartUpdate.next(cartId);
        this.stdCartMsg.next(true);
      }
    },
      (err) => {
        this.updateError.next(err);
      });
  }
  getUpdateMiniCart(): Observable<any> {
    return this.minicartUpdate.asObservable();
  }
  getCarts(userId): void {
    this.cartItems.next(false);
    if (userId) {
      this.baseService.get(config.USER_ACCOUNT + userId + '/carts?currentPage=0&fields=DEFAULT&pageSize=20&savedCartsOnly=false').subscribe((res) => {
        this.cartItems.next(res);
      });
    }
  }
  createCart(userId): void {
    this.createdCart = new BehaviorSubject<any>(false);
    this.createdCart$ = this.createdCart.asObservable();
    this.baseService.post(config.USER_ACCOUNT + userId + '/carts?fields=DEFAULT', {}).subscribe((res) => {
      this.createdCart.next(res);
    });
  }


  getReorderData(userId, shipToLocation): Observable<any> {
    return this.baseService.get(`${config.GET_REORDER_DATA}?customerId=${userId}&fields=DEFAULT&shipToLocations=${shipToLocation}`);
  }
  getProductPrices(req): Observable<any> {
    const asmEnabled = localStorage.getItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
    if (asmEnabled) {
      req['asm'] = true;
    }
    req['fields'] = 'DEFAULT';
    return this.baseService.get(`user/current/productprice`, req);
  }

  getFormularyData(): Observable<any> {
    return this.baseService.get(`products/formulary?fields=DEFAULT`);
  }
  getFormularyDataDefaultb2b(b2bUnitId): Observable<any> {
    return this.baseService.get(`products/formulary?b2bUnitUid=${b2bUnitId}&fields=DEFAULT`);
  }

  shareProductDetails(data: any, variantInfo?: any) {
    this.sharedProductDetails.next(data);
    if (variantInfo != '') {
      this.sharedProductVariantDetails.next(variantInfo);
    }

  }
}
